import { ValueSet } from "../types/fhir";

export const predefinedValueSet = [] as ValueSet[];
